<i18n src="@/locales/models/tech_visit.yml" lang="yaml"></i18n>
<i18n src="@/locales/views/service_provider/tech_visit/query/list_tech_visits.yml" lang="yaml" ></i18n>
<template>
  <bread-crumbs :labels="[module_name]" />
  <div v-if="load_data_general">
    <div class="mt-4 flex flex-row gap-2 justify-end">
      <div class="w-64 flex items-end" v-if="crop_fields.length > 0">
        <div class="mt-1">
          <switch-form
            v-model="show_crop_field_markers"
            :label="$t('labels.show_crop_field_markers')"
          />
        </div>
      </div>
      <div class="w-64" v-if="tech_visit_forms.length > 1">
        <label class="label-form">
          {{ $t("model.tech_visit.tech_visit_form_id") }}
        </label>
        <div class="mt-1">
          <select-form :options="tech_visit_forms" v-model="filters.tech_visit_form_id"></select-form>
        </div>
      </div>
      <div class="w-96" v-if="crop_fields.length > 0">
        <label class="label-form">
          {{ $t("labels.producer") }}
        </label>
        <div class="mt-1">
          <select-form :options="crop_fields" v-model="filters.crop_field_id"></select-form>
        </div>
      </div>
      <div class="w-64">
        <label class="label-form">
         {{ $t("labels.from_date") }}
        </label>
        <div class="mt-1">
          <date-form v-model="filters.from_date"></date-form>
        </div>
      </div>
      <div class="w-64">
        <label class="label-form">
          {{ $t("labels.to_date") }}
        </label>
        <div class="mt-1">
          <date-form v-model="filters.to_date"></date-form>
        </div>
      </div>
      <div class="w-64" v-if="inspectors.length > 1">
        <label class="label-form">
          {{ $t("model.tech_visit.inspector_id") }}
        </label>
        <div class="mt-1">
          <select-form :options="inspectors" v-model="filters.inspector_id"></select-form>
        </div>
      </div>
      <white-button :label="$t('labels.filter')" class="mt-6" @click="filterVisits" />
      <white-button v-if="filtered" :label="$t('labels.clear')" class="mt-6" @click="clearFilters" />
    </div>
    <div v-if="!loading_visits">
      <tech-visit-map class="mt-8" :tech-visits="tech_visits" :crop-fields="markedCropFields" :show-crop-fields="show_crop_field_markers" :key="show_crop_field_markers" v-if="tech_visits.length > 0"></tech-visit-map>
      <div class="mt-8 flex flex-row">
        <div class="panel-plain-label">
          <badge-default :label="total + ' ' + $t('labels.total')" />
        </div>
      </div>
      <div class="mt-2 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell"> {{ $t("model.tech_visit.ref_code") }} </th>
                    <th scope="col" class="table-header-cell"> {{ $t("model.tech_visit.registered_at") }} </th>
                    <th scope="col" class="table-header-cell"> {{ $t("model.tech_visit.producer_id") }} </th>
                    <th scope="col" class="table-header-cell"> {{ $t("labels.producer_code") }} </th>
                    <th scope="col" class="table-header-cell"> {{ $t("model.tech_visit.inspector_id") }} </th>
                    <th scope="col" class="table-header-cell" v-if="tech_visit_forms.length > 1">
                      {{ $t("model.tech_visit.tech_visit_form_id") }}
                    </th>
                    <template v-for="tech_visit_form in tech_visit_forms">
                      <template v-for="tech_visit_question in tech_visit_form.tech_visit_questions" :key="tech_visit_question.id">
                        <td class="table-header-cell">{{ tech_visit_question.label }}</td>
                      </template>
                    </template>
                    <th scope="col" class="table-header-cell"></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr class="table-row" v-for="tech_visit in tech_visits" :key="tech_visit.id">
                    <td class="table-cell-main link" @click.prevent="goToShow(tech_visit.id)">{{ tech_visit.ref_code }}</td>
                    <td class="table-cell">{{ dateFormatter(tech_visit.registered_at) }}</td>
                    <td class="table-cell">{{ tech_visit.crop_field?.producer?.fullname }}</td>
                    <td class="table-cell">{{ tech_visit.producer_code }}</td>
                    <td class="table-cell">{{ tech_visit.inspector?.name }}</td>
                    <td class="table-cell" v-if="tech_visit_forms.length > 1">
                      {{ tech_visit.tech_visit_form?.name }}
                    </td>
                    <template v-for="tech_visit_form in tech_visit_forms">
                      <template v-for="tech_visit_question in tech_visit_form.tech_visit_questions" :key="tech_visit_question.id">
                        <td class="table-cell">
                          <div v-html="techVisitAnswerRelevant(tech_visit, tech_visit_question)"></div>
                        </td>
                      </template>
                    </template>
                    <td class="table-cell-action">
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <table-paginator v-model="current_page" :total_rows="total" :rows_per_page="rows_per_page" />
    </div>

  </div>

  <loading-message v-else />
</template>

<script>
import moment from "moment";

import Requester from "@/views/service_provider/requesters/tech_visits/query/list_tech_visits.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import TechVisitMap from "@/components/views/service_provider/tech_visits/query/TechVisitMap.vue"

export default {
  components: { TablePaginator, TechVisitMap },
  props: {
    service_provider_id: { required: true }
  },
  data() {
    return {
      tech_visits: [],

      crop_fields: [],
      inspectors: [],
      tech_visit_forms: [],

      load_data_general: false,
      filtered: false,
      loading_visits: false,
      show_crop_field_markers: true,

      filters: {},
      current_page: 1,
      total: 0,
      rows_per_page: 8
    }
  },
  computed: {
    markedCropFields: function () {
      if (this.show_crop_field_markers)
        return this.crop_fields.filter(crop_field => crop_field.longitude && crop_field.latitude);
      return [];
    },
    canFilter: function () {
      return Object.values(this.filters).some(f => f !== "");
    },
    filtersFormated: function () {
      let filters  = {};
      Object.keys(this.filters).forEach(key => {
        if (key == "from_date" || key === "to_date") {
          filters[key] = this.filters[key] ? moment(this.filters[key]).format("YYYY-MM-DD") : null
        } else {
          filters[key] = this.filters[key];
        }
      });

      if (filters['from_date'] && filters['to_date'] && filters['from_date'] == filters['to_date']) {
        filters['registered_at'] = filters['from_date']
        filters['from_date'] = null
        filters['to_date'] = null
      }

      return filters;
    }
  },
  watch: {
    current_page: function () {
      this.fetchTechVisits();
    }
  },
  methods: {
    clearFilters: async function () {
      this.filters = { crop_field_id: null, tech_visit_form_id: null, from_date: null, to_date: null, inspector_id: null };
      await this.fetchTechVisits();
      this.filtered = false;
    },
    fetchTechVisits: async function (filters = {}) {
      this.loading_visits = true;
      let response = await Requester.fetchTechVisits({
        serviceProviderId: this.service_provider_id,
        currentPage: this.current_page,
        rowsPerPage: this.rows_per_page,
        filters
      });
      this.tech_visits = response.data.tech_visits;
      this.total = response.data.total;
      this.loading_visits = false;
    },
    fetchTechVisitForms: async function () {
      let response = await Requester.fetchTechVisitForms(this.service_provider_id);
      this.tech_visit_forms = response.data;
    },

    fetchTechVisitCropFields: async function () {
      let response = await Requester.fetchTechVisitCropFields(this.service_provider_id);
      this.crop_fields = response.data;
    },

    fetchTechVisitInspectors: async function () {
      let response = await Requester.fetchTechVisitInspectors(this.service_provider_id);
      this.inspectors = response.data;
    },

    filterVisits: async function () {
      if (!this.loading_visits && this.canFilter) {
        this.fetchTechVisits(this.filtersFormated);
        this.filtered = true;
      }
    },
    goToShow: function (techVisitId) {
      this.$router.push({
        name: this.routeName("show_tech_visit"),
        params: {
          serviceProviderId: this.service_provider_id,
          techVisitId: techVisitId
        }
      });
    },
    loadData: async function () {
      await this.fetchTechVisits();
      this.fetchTechVisitForms();
      this.fetchTechVisitInspectors();
      await this.fetchTechVisitCropFields();
      this.load_data_general = true;
    },
    techVisitAnswerRelevant: function (techVisit, techVisitQuestion) {
      return techVisit.tech_visit_answers
        .filter(answer => answer.tech_visit_question_id === techVisitQuestion.id)
        .map(answer => answer.tech_visit_answer_values).flat()
        .map((value) => {
          const indicatorOption = value.tech_visit_sub_question?.tech_visit_indicator_option?.label;
          if (indicatorOption) {
            return `${indicatorOption}: ${value.answer_value_label}`;
          } else {
            return value.answer_value_label;
          }
        }
      ).join("<br>");
    },
  },
  created() {
    this.checkIfAuthenticated()
      .then(() =>
        this.checkIfAuthorized({
          role: this.$route.meta.role,
          permission: this.$route.meta.permission,
          entity: {
            service_provider_id: this.service_provider_id,
          },
        }).then(() => {
          this.loadData();
        })
      );
  }
}
</script>
